import { combineReducers } from 'redux';

// local dependencies
import { REDUCER } from 'constants/entity-names';

/********************************************************/

// import reducers
import { updateAppContext } from 'store/reducers/updateAppContext';
import { userLoggedIn } from 'store/reducers/userLoggedIn';
import { addUrls } from 'store/reducers/addUrls';
import { addLabels } from 'store/reducers/addLabels';
import { addComponentData } from 'store/reducers/addComponentData';
import { callState } from 'store/reducers/callState';
import { checkoutState } from 'store/reducers/checkoutState';
import { memberVerificationState } from 'store/reducers/memberVerificationState';
import { memberManagementState } from 'store/reducers/memberManagementState';

/********************************************************/

// export combined reducer
// key of combined reducer is key of state, so be careful
export const combinedReducer = combineReducers( {
    [ REDUCER.APP_CONTEXT ]: updateAppContext,
	[ REDUCER.USER_SESSION ]: userLoggedIn,
	[ REDUCER.URLS ]: addUrls,
	[ REDUCER.LABELS ]: addLabels,
	[ REDUCER.COMPONENT_DATA ]: addComponentData,
	[ REDUCER.CALL_STATE ]: callState,
	[ REDUCER.CHECKOUT_STATE ]: checkoutState,
	[ REDUCER.MEMBER_VERIFICATION_STATE ]: memberVerificationState,
	[ REDUCER.MEMBER_MANAGEMENT_STATE ]: memberManagementState
} );
